<template>
    <div class="FormItem">
      <template v-for="items in displayColumns">
        <el-row :key="items.row">
          <el-col v-for="item in items.formObj" :span="item.col" :key="item.key">
            <el-form-item :label="item.typeExtends === 'divi'?'':item.label" :label-width="item.typeExtends === 'divi'?'20px':'140px'" :prop="item.prop">
              <div v-if="item.typeExtends === 'input'">
                <div v-if="item.mainKey === true">
                  <el-input v-if="item.hq == ''" v-model="objProps[item.prop]" :disabled="isMainKeyProp || item.readOnly"></el-input>
                  <hqry-input v-else :code="item.hq" :prop="item.prop" :obj="objProps" :rstField="item.rstField" :disabled="isMainKeyProp || item.readOnly"></hqry-input>
                </div>
                <div v-else>
                  <el-input v-model.number="objProps[item.prop]" v-if="item.type === 'int'" :disabled="item.readOnly"></el-input>
                  <div v-else-if="item.hq !== ''">
                    <mh-link v-if="formDisabled && item.refObj !== ''" :src="item.refObj" mType="sRouter" :content="objProps[item.prop]" :mNbr="objProps[item.prop]" ></mh-link>
                    <hqry-input v-else :code="item.hq" :prop="item.prop" :obj="objProps" :rstField="item.rstField" :disabled="item.readOnly"></hqry-input>
                  </div>
                  <div v-else>
                    <el-input v-if="item.refObj === ''" v-model="objProps[item.prop]" :disabled="item.readOnly" :clearable="item.clearable"></el-input>
                    <mh-link v-else-if="formDisabled" :src="item.refObj" mType="sRouter" :content="objProps[item.prop]" :mNbr="objProps[item.prop]" ></mh-link>
                    <el-input v-else v-model="objProps[item.prop]" :disabled="item.readOnly" :clearable="item.clearable">
                      <i slot="prefix" class="el-input__icon el-icon-search color-blue mouse-pointer" @click="openRefObj(item.refObj, objProps[item.prop])"></i>
                    </el-input>
                  </div>
                </div>
              </div>
              <div v-else-if="item.typeExtends === 'checkbox'">
                <el-checkbox v-model="objProps[item.prop]" :disabled="item.readOnly"></el-checkbox>
              </div>
              <div v-else-if="item.typeExtends === 'select'">
                <div v-if="item.mainKey === true">
                  <el-select v-model="objProps[item.prop]" :disabled="isMainKeyProp || item.readOnly" :clearable="item.clearable" filterable>
                    <el-select-options :item="item.mapValues"></el-select-options>
                  </el-select>
                </div>
                <div v-else>
                  <el-select v-model="objProps[item.prop]" :disabled="item.readOnly" :clearable="item.clearable" filterable>
                    <el-select-options :item="item.mapValues"></el-select-options>
                  </el-select>
                </div>
              </div>
              <div v-else-if="item.typeExtends === 'tagselect'">
                <div v-if="item.mainKey === true">
                  <el-select v-model="objProps[item.prop]" :disabled="isMainKeyProp || item.readOnly" :clearable="item.clearable" filterable>
                    <tag-select-options :item="item.mapValues"></tag-select-options>
                  </el-select>
                </div>
                <div v-else>
                  <el-select v-model="objProps[item.prop]" :disabled="item.readOnly" :clearable="item.clearable" filterable>
                    <tag-select-options :item="item.mapValues"></tag-select-options>
                  </el-select>
                </div>
<!--                <div v-if="item.mainKey === true">-->
<!--                  <mh-tag-select :mObj="objProps" :mProp="item.prop" :mReadOnly="isMainKeyProp || item.readOnly" :mClearAble="item.clearable" :mMapValues="item.mapValues"></mh-tag-select>-->
<!--                </div>-->
<!--                <div v-else>-->
<!--                  <mh-tag-select :mObj="objProps" :mProp="item.prop" :mReadOnly="item.readOnly" :mClearAble="item.clearable" :mMapValues="item.mapValues"></mh-tag-select>-->
<!--                </div>-->
              </div>
              <div v-else-if="item.typeExtends === 'colorselect'">
<!--                <mh-color-select :mObj="objProps" :mProp="item.prop" :mReadOnly="item.readOnly" :mClearAble="item.clearable" :mMapValues="item.mapValues"></mh-color-select>-->
                <mh-color-select :mObj="objProps" :mProp="item.prop" :mReadOnly="item.readOnly" :mClearAble="item.clearable"></mh-color-select>
<!--                <icon-element :mObj="objProps" :mProp="item.prop" :mClearAble="item.clearable" :mReadOnly="formDisabled"></icon-element>-->
              </div>
              <div v-else-if="item.typeExtends === 'mselect'">
                <mh-multiple-select :mObj="objProps" :mProp="item.prop" :mReadOnly="item.readOnly" :mClearAble="item.clearable" :mMapValues="item.mapValues"></mh-multiple-select>
              </div>
              <div v-else-if="item.typeExtends === 'tkselect'">
                <el-select v-model="objProps[item.prop]" :disabled="item.readOnly" :clearable="item.clearable" filterable>
                  <el-select-options :item="item.mapValues"></el-select-options>
                </el-select>
              </div>
              <div v-else-if="item.typeExtends === 'radiogroup'">
                <el-radio-group v-model="objProps[item.prop]" :disabled="item.readOnly" text-color="#ffffff" fill="#409EFF">
                  <mh-radio :item="item.mapValues"></mh-radio>
                </el-radio-group>
              </div>
              <div v-else-if="item.typeExtends === 'date'">
                <el-date-picker type="date" v-model="objProps[item.prop]" :disabled="item.readOnly" :clearable="item.clearable" :format="item.format" :value-format="item.format"></el-date-picker>
              </div>
              <div v-else-if="item.typeExtends === 'datetime'">
                <el-date-picker type="datetime" v-model="objProps[item.prop]" :disabled="item.readOnly" :clearable="item.clearable" :format="item.format" :value-format="item.format"></el-date-picker>
              </div>
              <div v-else-if="item.typeExtends === 'time'">
                <el-time-picker v-model="objProps[item.prop]" default-value="1980-01-01 00:00:00.000" :disabled="item.readOnly" :clearable="item.clearable" :format="item.format" value-format="yyyy-MM-dd HH:mm"></el-time-picker>
              </div>
              <div v-else-if="item.typeExtends === 'textarea'">
                <el-input type="textarea" :rows="item.textRows" v-model="objProps[item.prop]" :disabled="item.readOnly" :clearable="item.clearable"></el-input>
              </div>
              <div v-else-if="item.typeExtends === 'quilledit'">
                <mh-quill-editor :mObj="objProps" :mProp="item.prop" :fileProps="item.efileParas" :editdisable="formDisabled"></mh-quill-editor>
              </div>
              <div v-else-if="item.typeExtends === 'efile'">
                <single-upload-buttons :mObj="objProps" :mProp="item.prop" :fileProps="item.efileParas" :disabled="item.readOnly" :formDisabled="formDisabled" position="form"></single-upload-buttons>
              </div>
              <div v-else-if="item.typeExtends === 'fixedefile'">
                <single-upload-buttons :mObj="objProps" :mProp="item.prop" :fileProps="item.efileParas" :disabled="item.readOnly" :formDisabled="formDisabled" position="form"></single-upload-buttons>
              </div>
              <div v-else-if="item.typeExtends === 'mefile'">
                <multiple-upload-buttons :mainObj="objProps" :mProp="item.prop" :fileProps="item.efileParas" :disabled="item.readOnly" :formDisabled="formDisabled" position="form"></multiple-upload-buttons>
              </div>
              <div v-else-if="item.typeExtends === 'label'">
                <span class="form-span-label">{{objProps[item.prop]}}</span>
              </div>
              <div v-else-if="item.typeExtends === 'divi'">
                <el-divider :content-position="item.align"><i :class="item.icon"></i>{{item.label}}</el-divider>
              </div>
              <div v-else-if="item.typeExtends === 'icon'">
                <icon-element :mObj="objProps" :mProp="item.prop" :mClearAble="item.clearable" :mReadOnly="formDisabled"></icon-element>
              </div>
              <div v-else-if="item.typeExtends === 'jscodeedit'">
                <el-input v-model="objProps[item.prop]" disabled>
                  <code-edit-btn slot="append"
                                 :mTitle="'JS Code Editor'"
                                 :mCode="objProps[item.prop]"
                                 :mObj="objProps"
                                 :mProp="item.prop">
                  </code-edit-btn>
                </el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </div>

</template>

<script>
import ElSelectOptions from '@/components/base/ElSelectOptions.vue'
import CodeEditBtn from '@/components/base/CodeEditBtn.vue'
import MhQuillEditor from '@/components/base/MhQuillEditor.vue'
import SingleUploadButtons from '@/components/base/SingleUploadButtons.vue'
import MhMultipleSelect from '@/components/base/MhMultipleSelect.vue'
import IconElement from '@/components/base/IconElement.vue'
import MhLink from '@/components/base/MhLink.vue'
import MultipleUploadButtons from '@/components/base/MultipleUploadButtons.vue'
import MhRadio from '@/components/base/MhRadio.vue'
import MhColorSelect from '@/components/base/MhColorSelect.vue'
import TagSelectOptions from '@/components/base/TagSelectOptions.vue'
// import MhTagSelect from '@/components/base/MhTagSelect.vue'
export default {
  name: 'FormItem',
  props: ['columns', 'objProps', 'isMainKeyProp', 'formDisabled'],
  computed: {
    displayColumns () {
      // const array = this.$Any.newArraySortByKey(this.columns, 'formOrder')
      // return array.filter(item => {
      //   return item.formDisplay === true
      // })
      const that = this
      const rowArray = []
      const items = []
      let row = -1
      let item = {}
      // const array = this.$Any.newArraySortByKey(this.columns, 'row')
      const tempColumns = that.$Any.newArraySortByKey(that.$Any.arrayCopy(that.columns), 'row')
      for (const i in tempColumns) {
        if (row !== tempColumns[i].row) {
          row = tempColumns[i].row
          rowArray.push(row)
        }
      }
      for (let j = 0; j < rowArray.length; j++) {
        const r = rowArray[j]
        item = {
          row: r,
          formObj: []
        }
        const formObjs = []
        for (const k in tempColumns) {
          if ((r === tempColumns[k].row) && (tempColumns[k].formDisplay === true)) {
            formObjs.push(tempColumns[k])
            // tempColumns.splice(k, 1)
          }
        }
        item.formObj = that.$Any.newArraySortByKey(formObjs, 'formOrder')
        items.push(item)
      }
      return that.$Any.newArraySortByKey(items, 'row')
    },
    hidden () {
      return false
    }
  },
  components: {
    MhRadio,
    ElSelectOptions,
    CodeEditBtn,
    MhQuillEditor,
    SingleUploadButtons,
    MhMultipleSelect,
    MhLink,
    IconElement,
    MultipleUploadButtons,
    MhColorSelect,
    // MhTagSelect,
    TagSelectOptions
  },
  methods: {
    openRefObj: async function (srcObj, Nbr) {
      if ((Nbr) && (Nbr !== '')) {
        const that = this
        const stl = await that.$Any.getStaticRouterUrl(srcObj, Nbr)
        const para = {}
        para.id = srcObj
        para.nbr = Nbr
        para.lot = ''
        para.code = ''
        that.$Any.pushRouter(that.$router, stl, Nbr, para)
      }
    }
  }
}
</script>

<style lang="less" scoped>
 /deep/
.el-form-item .el-form-item__content .el-form-item__error {
  position: static;
}

</style>
